export default "__VITE_ASSET__C1XuUyDV__"